import { render, staticRenderFns } from "./HeroLatam.vue?vue&type=template&id=b306aa4a&scoped=true"
import script from "./HeroLatam.js?vue&type=script&lang=js&external"
export * from "./HeroLatam.js?vue&type=script&lang=js&external"
import style0 from "./HeroLatam.scss?vue&type=style&index=0&id=b306aa4a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b306aa4a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default,HotImage: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Image/Image.vue').default,HotVideoInline: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/VideoInline/VideoInline.vue').default})
